export type PaginationPage = {
  type: 'page';
  pageNumber: number;
  current: boolean;
};

export type PaginationGap = {
  type: 'gap';
};

export type PaginationButton = PaginationPage | PaginationGap;

export const getPagination = (
  totalNumberItems: number,
  currentPage: number,
  pageSize: number,
): PaginationButton[] => {
  if (totalNumberItems === 0 || pageSize < 1) {
    return [];
  }

  const numberPages = Math.ceil(totalNumberItems / pageSize);
  const page = Math.min(Math.max(currentPage, 1), numberPages);

  if (numberPages <= 4) {
    return range(1, numberPages).map((pageNumber) => ({
      type: 'page',
      pageNumber,
      current: pageNumber === page,
    }));
  }

  const pages = new Set([1, numberPages, page]);
  if (page - 1 > 1) {
    pages.add(page - 1);
  }
  if (page + 1 < numberPages) {
    pages.add(page + 1);
  }

  const sorted = [...pages].sort((a, b) => a - b);
  const buttons: PaginationButton[] = [];
  let previous = 0;

  for (const pageNumber of sorted) {
    if (previous > 0 && pageNumber - previous > 1) {
      buttons.push({ type: 'gap' });
    }

    buttons.push({
      type: 'page',
      pageNumber,
      current: pageNumber === page,
    });
    previous = pageNumber;
  }

  return buttons;
};

const range = (from: number, to: number): number[] =>
  Array.from({ length: to - from + 1 }, (_, index) => from + index);
